import cn from 'classnames';

import s from './FileCard.module.scss';
import { FileTypeIcon, getFileTypeChipKey } from './FileCardIcons';
import type { FileCardAttrs } from './fileCard.types';
import { formatFileSize } from './fileCard.utils';

/** Metadata tag — label:value pill */
export const MetaTag = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <span className={s.metaTag}>
    <span className={s.metaLabel}>{label}:</span> <span className={s.metaValue}>{value}</span>
  </span>
);

/** Icon + ext chip + file size column */
export const FileIcon = ({ attrs }: { attrs: FileCardAttrs }) => (
  <div className={s.iconCol}>
    <div className={s.iconWrap}>
      <FileTypeIcon ext={attrs.ext} size={44} />
      {!!attrs.ext && (
        <span className={cn(s.extChip, s[getFileTypeChipKey(attrs.ext)])}>
          {attrs.ext.replace('.', '')}
        </span>
      )}
    </div>
    {!!attrs.size && <span className={s.fileSize}>{formatFileSize(attrs.size)}</span>}
  </div>
);
